module.exports = __webpack_public_path__ + "media/images/icons/outlined/barcode-5c0fce84135d92930bc77caca3b43e24.svg";